import { DocumentsProvider } from './../../providers/documents/documents';
import { Component, Input } from '@angular/core';
import { NavController, NavParams, App, Platform, ToastController, LoadingController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { File } from '@ionic-native/file';
import { ToastHelper } from '../../helpers/toastr-helper';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { LoaderHelper } from '../../helpers/loader-helper';
import { FileOpener } from '@ionic-native/file-opener';
import { User } from '../../providers/user/user';

@Component({
    selector: 'event-documents',
    templateUrl: 'event-documents.html',
})
export class EventDocumentsComponent {
    @Input()
    event: any;

    constructor(
        public app: App,
        public navCtrl: NavController,
        public navParams: NavParams,
        public http: HttpClient,
        private documentsProvider: DocumentsProvider,
        private file: File,
        public platform: Platform,
        private toastCtrl: ToastController,
        private androidPermissions: AndroidPermissions,
        public loadingCtrl: LoadingController,
        private fileOpener: FileOpener,
        private userProvider: User
    ) {

    }

    ngOnInit() { }

    viewProfile(userId: string, eventId: string): void {
        if ( userId !== this.userProvider.currentUser().uuid) {
            this.app.getRootNav().push('ProfilePage', {
                userId: userId,
                event: eventId,
            });
        }
    }

    async downloadDocument(documentUrl: string, name: string) {
        LoaderHelper.Show(this.loadingCtrl);
        const formatName = name.replace(/[^\w\s]/gi, ' ');
        this.documentsProvider.downloadDocument(documentUrl).subscribe(response => {
            if (this.isNative()) {
                console.log('FORMATTED NAME: ', formatName)
                this.downloadFileNative(response, formatName);
            } else {
                this.downloadFile(response, formatName);
            }
        });
    }

    downloadFile(blob: any, name: string) {
        const url = window.URL.createObjectURL(blob);

        const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        LoaderHelper.Hide();
    }

    async downloadFileNative(imageBlob: any, name: string) {
        this.androidPermissions.hasPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE)
            .then(async status => {
                if (status.hasPermission) {
                    await this.saveFile(imageBlob, name);
                }
                else {
                    this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE)
                        .then(async status => {
                            if (status.hasPermission) {
                                await this.saveFile(imageBlob, name);
                            } else {
                                LoaderHelper.Hide();
                            }
                        });
                }
            });
    }

    async saveFile(imageBlob: any, name: string) {
        console.log("File name: ", name);
        console.log("Data dir: ", this.file.externalRootDirectory + 'Download/');
        let response = await this.file.writeFile(this.file.externalRootDirectory + 'Download/', name + ".pdf", imageBlob, { replace: true });
        console.log(response);
        LoaderHelper.Hide();
        ToastHelper.Show(this.toastCtrl, "File saved to Download folder");
        this.fileOpener.open(response.nativeURL, 'application/pdf')
            .then(() => console.log('File is opened'))
            .catch(e => console.log('Error opening file', e));
    }

    isNative() {
        return this.platform.is('cordova');
    }
}



// WEBPACK FOOTER //
// ./src/components/event-documents/event-documents.ts